import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent {

  accordionItems = [
    {
        value: 'getStarted',
        label: 'Let\'s get started',
        content: {
          text: '',
          list: [
            'Item 1', 'Item 2', 'Item 3'
          ]
        },
    },
    {
        value: 'tracking',
        label: 'Track individual match',
        content: 'Track individual match content',
        subItems: [
          {
            value: 'tracking1',
            label: 'Track individual match',
            content: {
              text: '',
              list: [
                'Item 1', 'Item 2', 'Item 3'
              ]
            },          },
          {
            value: 'tracking2',
            label: 'Track individual match',
            content: {
              text: 'Content text',
              list: [
                'Item 1', 'Item 2', 'Item 3'
              ]
            },          }
            
        ]
    },
    {
        value: 'teamMatch',
        label: 'Setup and manage team matches',
        content: 'Setup and manage team matches content',
        subItems: [
            
        ]
    },
    {
        value: 'offcials',
        label: 'Chair official\'s support',
        content: 'Setup and manage team matches content',
        subItems: [
            
        ]
    }
  ]

  constructor() { }

}
